module.exports = __webpack_public_path__ + "media/images/list_practice/4-01-273ecd79a65d39912a9da74621bf0072.svg";